import React, { useState } from 'react';
import { Link } from 'react-router-dom'

function ButtonLinkHover (props) {

  const [hoverLinkButton, setHoverLinkButton] = useState({
    padding: '20px 40px',
    margin: '20px',
    border: '1px solid #fff',
    borderRadius: '4px',
    textTransform: 'uppercase',
    fontWeight: '700',
    textAlign: 'center',
    background: '#80a3db',
    color: '#fff',
    textDecoration: 'none',
  });

  return(
      <div style={{
          height: '50px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}>
        <Link
          to={props.pageRef}
          style={hoverLinkButton}
          onMouseEnter={() => setHoverLinkButton({
            padding: '20px 40px',
            margin: '20px',
            border: '1px solid #fff',
            borderRadius: '4px',
            textTransform: 'uppercase',
            fontWeight: '700',
            textAlign: 'center',
            background: '#fff',
            color: '#80a3db',
            textDecoration: 'none',
          })}
          onMouseLeave={() => setHoverLinkButton({
            padding: '20px 40px',
            margin: '20px',
            border: '1px solid #fff',
            borderRadius: '4px',
            textTransform: 'uppercase',
            fontWeight: '700',
            textAlign: 'center',
            background: '#80a3db',
            color: '#fff',
            textDecoration: 'none',
          })}
          >
          {props.buttonName}
        </Link>
    </div>
  )
}

export default ButtonLinkHover
